import { render, staticRenderFns } from "./EquipMgmtCtrlDetail.vue?vue&type=template&id=27e8c4b9&scoped=true"
import script from "./EquipMgmtCtrlDetail.vue?vue&type=script&lang=js"
export * from "./EquipMgmtCtrlDetail.vue?vue&type=script&lang=js"
import style0 from "./EquipMgmtCtrlDetail.vue?vue&type=style&index=0&id=27e8c4b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8c4b9",
  null
  
)

export default component.exports